import React, { useEffect, useState, memo, useRef } from "react";
import { MapNoDataMsg, MapNoDataWrap } from "./styled/WebMap.styled";

const useApiCount = (apiCount) => {
  const [prevCount, setPrevCount] = useState(apiCount);
  const [countBecameZero, setCountBecameZero] = useState(false);

  useEffect(() => {
    setPrevCount(apiCount);
    if (prevCount > 0 && apiCount === 0) {
      setCountBecameZero(true);
    } else {
      setCountBecameZero(false);
    }
  }, [apiCount]);

  return countBecameZero;
};

const useVisible = (eyeIcons, ecoSiteVisible, optrSiteVisible) => {
  const [prev, setPrev] = useState({ eye: eyeIcons, eco: ecoSiteVisible, optr: optrSiteVisible });
  const [sectionOff, setSectionOff] = useState(false);

  useEffect(() => {
    setPrev({ eye: eyeIcons, eco: ecoSiteVisible, optr: optrSiteVisible });
    const { supply, demand, capacity, sites, ibs } = eyeIcons;
    const { supply: pSup, demand: pDem, capacity: pCap, sites: pSi, ibs: pIbs } = prev.eye;
    if ((pSup && !supply) || (pDem && !demand) || (pCap && !capacity) || (pSi && !sites) || (prev.eco && !ecoSiteVisible) || (prev.optr && !optrSiteVisible) || (pIbs && !ibs)) {
      setSectionOff(true);
    } else {
      setSectionOff(false);
    }
  }, [eyeIcons, ecoSiteVisible, optrSiteVisible]);

  return sectionOff;
};

const WebMapNoData = ({
  canShow = false,
  apiCount = 0,
  eyeIcons,
  optrSiteVisible,
  ecoSiteVisible,
  ibsVisible
}) => {
  const [divWidth, setDivWidth] = useState(0);
  const [show, setShow] = useState(false);
  const isApiCountDrop = useApiCount(apiCount);
  const isSectionOff = useVisible(eyeIcons, ecoSiteVisible, optrSiteVisible,ibsVisible);
  const apiCountRef = useRef(apiCount);

  useEffect(() => {
    const divElement = document.getElementById('map-right');
    if (divElement) {
      const handleResize = () => {
        const newWidth = divElement.offsetWidth;
        setDivWidth(newWidth);
      };
      const resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(divElement);
      return () => {
        resizeObserver.unobserve(divElement);
      };
    }
  }, []);

  useEffect(() => {
    apiCountRef.current = apiCount;
    if ((isApiCountDrop || isSectionOff) && canShow && apiCount === 0 && !isDataOnMap()) {
      setTimeout(() => {
        if (!isDataOnMap() && apiCountRef.current === 0) setShow(true);
      }, 2000);
    }
    else setShow(false);
  }, [isApiCountDrop, isSectionOff, canShow]);

  const isDataOnMap = () => {
    const mapRightDiv = document.getElementById('map-right');
    const element = mapRightDiv?.querySelector('div.data-on-map');
    const isAvailable = !!element;
    return isAvailable;
  };

  return (
    <>
      <MapNoDataWrap
        show={show}
        wd={divWidth + 'px'}
        onClick={() => {
          setShow(false);
        }}
      >
        <MapNoDataMsg>
          No data available for comparison
        </MapNoDataMsg>
      </MapNoDataWrap>
    </>
  );
}

export default memo(WebMapNoData);